import { render, staticRenderFns } from "./AIChatWidgetPdpImageSetPickerLegacy.vue?vue&type=template&id=1a1caaf8&scoped=true"
import script from "./AIChatWidgetPdpImageSetPickerLegacy.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetPdpImageSetPickerLegacy.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetPdpImageSetPickerLegacy.vue?vue&type=style&index=0&id=1a1caaf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1caaf8",
  null
  
)

export default component.exports